import moment from "moment";

const DISPLAY_FORMAT = "DD-MM-YYYY HH:mm";

export const formatDate = (date) => {
  if (!date) return "-";

  const parsedDate = moment(date, [DISPLAY_FORMAT, moment.ISO_8601]);

  return parsedDate.isValid() ? parsedDate.format(DISPLAY_FORMAT) : date;
};
